import { useTranslation } from 'react-i18next';
import { SocialAccountStatus, SocialAccountType } from '@anytag/graphql';
import { useGenerateInfluencerProfileLink } from '@anytag/shared-hooks';
import {
  PostsSection,
  InfluencerAvatar,
  InfluencerPostDetailsModal,
  InfluencerWidgetInformation
} from '@anytag/shared-molecules';
import { bigIntFormatter, formatPercent } from '@anytag/shared-utils';
import { StatsSection, ProfileWidgetTemplate, SimilarInfluencersButton } from '../../shared';
import { DefaultProfileWidgetProps } from '../../schemaTypes';
import { TiktokInfluencerProfile } from '../schemaTypes';

type ProfileWidgetProps = DefaultProfileWidgetProps<TiktokInfluencerProfile>;

export const ProfileWidget = ({
  className,
  isSectionOpened,
  selectButtonProps,
  toggleSimilarInfluencersSection,
  profile: {
    id,
    age,
    name,
    posts,
    avatar,
    gender,
    country,
    averageLikes,
    averageViews,
    isTTCMCreator,
    isBrandAccount,
    socialAccountId,
    socialAccountStatus,
    socialAccountFollowers,
    socialAccountEngagementViewsRate,
    socialAccountEngagementFollowersRate
  }
}: ProfileWidgetProps) => {
  const { t } = useTranslation();
  const { generateProfileLink } = useGenerateInfluencerProfileLink();

  const isSignedUp = socialAccountStatus === SocialAccountStatus.SIGNED_UP;
  const stats = [
    { label: t('HeaderColumn.Followers'), value: bigIntFormatter(socialAccountFollowers || 0) },
    { label: t('HeaderColumn.Egg Rate by followers'), value: formatPercent(socialAccountEngagementFollowersRate) },
    { label: t('HeaderColumn.Egg Rate by views'), value: formatPercent(socialAccountEngagementViewsRate) },
    { label: t('HeaderColumn.Avg Views'), value: bigIntFormatter(averageViews || 0, 0) },
    { label: t('HeaderColumn.Avg Likes'), value: bigIntFormatter(averageLikes || 0, 0) }
  ];
  const profileUrl = generateProfileLink(id, { filter: { id: String(socialAccountId), sm: SocialAccountType.TIKTOK } });

  return (
    <ProfileWidgetTemplate className={className} selectButtonProps={selectButtonProps}>
      <InfluencerAvatar
        size="80px"
        src={avatar}
        isBrandAccount={isBrandAccount}
        socialAccountType={SocialAccountType.TIKTOK}
      />

      <InfluencerWidgetInformation
        age={age}
        name={name}
        gender={gender}
        country={country}
        profileUrl={profileUrl}
        isTTCMCreator={isTTCMCreator}
        isSignedUp={isSignedUp}
      >
        {toggleSimilarInfluencersSection ? (
          <SimilarInfluencersButton isActive={isSectionOpened} onClick={() => toggleSimilarInfluencersSection?.()} />
        ) : null}
      </InfluencerWidgetInformation>

      <StatsSection id={id} stats={stats} />

      <PostsSection posts={posts} influencerId={id} css={{ marginLeft: '16px' }} />
      <InfluencerPostDetailsModal posts={posts} />
    </ProfileWidgetTemplate>
  );
};
